/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function WifiNone(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,219.70508a15.90814,15.90814,0,0,1-12.14014-5.64844L12.8999,92.709a16.182,16.182,0,0,1-3.71826-12.206,15.97026,15.97026,0,0,1,6.208-10.95752c66.30371-50.03418,158.91748-50.03516,225.22119,0a15.97226,15.97226,0,0,1,6.20752,10.957A16.18377,16.18377,0,0,1,243.10059,92.708L140.14014,214.05664A15.90814,15.90814,0,0,1,128,219.70508ZM25.084,82.27441a.12788.12788,0,0,0,.01612.083l102.89844,121.2749L230.8999,82.35693a.16373.16373,0,0,0,.01074-.11767C170.36279,36.57764,85.709,36.563,25.084,82.27441Zm-.05664.04248ZM20.2085,75.93115h0Z" />
    </Svg>
  );
}

export default WifiNone;
